module.exports = __webpack_public_path__ + "img/icon-card-4.ae51d53e.webp";